import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./timezone-selector.component.html?ngResource";
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TreeSelectModule } from 'primeng/treeselect';
import { TimezoneService } from 'src/ng-app/shared/services/timezone.service';
let TimezoneSelectorComponent = class TimezoneSelectorComponent {
    timezoneService;
    selectedTimezone = null;
    timezoneChange = new EventEmitter();
    get value() {
        return this.selectedTimezone?.timezoneId;
    }
    set value(value) {
        this.selectedTimezone = this.timezoneService.getTimezoneById(value) || null;
    }
    availableTZNodes = [];
    selectedTZNode = null;
    _timezoneNodesMap = new Map();
    constructor(timezoneService) {
        this.timezoneService = timezoneService;
    }
    ngOnInit() {
        const timezonesByContinent = this.timezoneService.getSortedTimezones();
        this.availableTZNodes = timezonesByContinent.map((continent) => {
            const node = this.createTZNode(continent, 'continent');
            node.children = continent.regions.map((region) => this.createTZNode(region, 'region'));
            return node;
        });
        if (this.selectedTimezone) {
            this.setSelectedTZNode(this.selectedTimezone);
        }
    }
    createTZNode(timezone, type) {
        const key = type === 'continent' ? timezone.continent : timezone.timezoneId;
        const label = type === 'continent' ? timezone.continent : timezone.label;
        const timezoneNode = {
            key,
            type,
            data: timezone,
            label,
            selectable: type === 'region',
        };
        this._timezoneNodesMap.set(key, timezoneNode);
        return timezoneNode;
    }
    ngOnChanges(changes) {
        if (changes.selectedTimezone && changes.selectedTimezone.currentValue) {
            this.setSelectedTZNode(changes.selectedTimezone.currentValue);
        }
        if (changes.value?.firstChange === false || this.selectedTimezone?.timezoneId !== this.selectedTZNode?.key) {
            this.setSelectedTZNode(this.selectedTimezone);
        }
    }
    setSelectedTZNode(timezone) {
        if (!timezone) {
            this.selectedTZNode = null;
            return;
        }
        const timezoneId = timezone.timezoneId;
        const selectedTZNode = this._timezoneNodesMap.get(timezoneId);
        if (selectedTZNode) {
            this.selectedTZNode = selectedTZNode;
        }
    }
    onNodeSelect(event) {
        const timezoneId = event.node?.data?.timezoneId;
        this.selectedTimezone = timezoneId ? this.timezoneService.getTimezoneById(timezoneId) : null;
        this.timezoneChange.emit(this.selectedTimezone);
    }
    onNodeExpand(event) {
        this.availableTZNodes.forEach((continent) => {
            if (continent.key !== event.node.key) {
                continent.expanded = false;
            }
        });
    }
    static ctorParameters = () => [
        { type: TimezoneService }
    ];
    static propDecorators = {
        selectedTimezone: [{ type: Input }],
        timezoneChange: [{ type: Output }],
        value: [{ type: Input }]
    };
};
TimezoneSelectorComponent = __decorate([
    Component({
        selector: 'timezone-selector',
        template: __NG_CLI_RESOURCE__0,
        standalone: true,
        imports: [CommonModule, FormsModule, TreeSelectModule],
    })
], TimezoneSelectorComponent);
export { TimezoneSelectorComponent };
